import { APP_UPDATE_AVAILABLE } from '../actions/appupdate'

const initialState = {
  appUpdateAvailable: false
}

export function appupdate(state = initialState, action) {
  switch (action.type) {
    case APP_UPDATE_AVAILABLE:
      return Object.assign({}, state, {
        appUpdateAvailable: true
      })
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/appupdate.js